<template>
  <b-container class="mt-5">
    <b-row>
      <b-col md="6" lg="6">
        <b-form-group>
          Date de début
          <b-form-input
            onfocus="(this.type='date')"
            onBlur="(this.type='text')"
            size="sm"
            placeholder="Date d'enregistrement"
            type="text"
            v-model="dateDebut"
            :state="dateDebut === null ? null : dateDebut != ''"
          />
        </b-form-group>
      </b-col>
      <b-col md="6" lg="6">
        <b-form-group>
          Date de fin
          <b-form-input
            onfocus="(this.type='date')"
            onBlur="(this.type='text')"
            size="sm"
            placeholder="Date d'enregistrement"
            type="text"
            v-model="dateFin"
            :max="dateMax"
            :state="dateFin === null ? null : dateFin != ''"
          />
        </b-form-group>
      </b-col>

      <b-col md="12" lg="12" v-if="msgNoSelected != ''">
        <b-alert show variant="warning" class="mt-2">{{
          msgNoSelected
        }}</b-alert>
      </b-col>

      <b-col md="6">
        <b-table
          striped
          hover
          bordered
          responsive
          stacked="true"
          :items="analyses"
          :fields="fields"
          selectable
          select-mode="single"
          selectedVariant="success"
          @row-selected="selectAnalyse"
        >
          <div slot="table-busy" class="text-center">
            <b-spinner class="align-middle color_green_labco" type="grow" />
          </div>
        </b-table>
      </b-col>

      <b-col md="6">
        <b-table
          striped
          hover
          bordered
          responsive
          stacked="true"
          :items="analysesSelected"
          :fields="fieldsSelected"
        >
          <div slot="table-busy" class="text-center">
            <b-spinner class="align-middle color_green_labco" type="grow" />
          </div>
        </b-table>
      </b-col>

      <b-col md="12" lg="12" v-if="msgsErrorSave.length > 0">
        <template v-for="(error, i) in msgsErrorSave">
          <b-col :key="i">
            <b-alert
              show
              variant="danger"
              class="mt-2"
              v-html="error.message"
            ></b-alert>
          </b-col>
        </template>
      </b-col>

      <b-col md="12" lg="12">
        <b-button class="float-right mb-3" variant="success" @click="exportCSV"
          >Exporter la synthèse</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import api from './../api.js'
import moment from 'moment'

export default {
  name: 'SyntheseComponent',
  data () {
    return {
      dateDebut: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      dateFin: moment().format('YYYY-MM-DD'),
      analyses: [],
      dateMax: moment().format('YYYY-MM-DD'),
      fields: [{
        key: 'data.libelle',
        label: 'Libellé',
        sortable: true
      }
      ],
      fieldsSelected: [{
        key: 'anag_num',
        label: 'n°',
        sortable: true
      },
      {
        key: 'libelle',
        label: 'Libellé',
        sortable: true
      }
      ],
      analysesSelected: [],
      msgsErrorSave: [],
      msgNoSelected: ''
    }
  },
  computed: {
    dateDbt: function () {
    }
  },
  mounted () {
    this.getSyntheses()
  },
  methods: {
    getSyntheses () {
      api.getSyntheses()
        .done((data) => {
          this.analyses = []
          this.msgsErrorSave = []
          Object.keys(data.data).map((cle) => {
            this.analyses.push({
              key: cle,
              data: data.data[cle]
            })
          })
        })
        .fail((xhr) => {
          window.fail(xhr, true)
        })
    },
    selectAnalyse (item) {
      this.analysesSelected = item[0].data.analyses
    },
    exportCSV () {
      let error = false
      this.dateDebut = this.dateDebut === null ? '' : this.dateDebut
      this.dateFin = this.dateFin === null ? '' : this.dateFin

      if (this.dateDebut === '' || this.dateFin === '') error = true
      if (this.analysesSelected.length === 0) {
        this.msgNoSelected = 'Vous devez sélectionner une synthèse à exporter'
        error = true
      }

      if (error) return

      api.exportCSV(this.dateDebut, this.dateFin, this.analysesSelected)
        .done((data) => {
          this.downloadFile(data, 'syntheses')
        })
        .fail((xhr) => {
          this.msgsErrorSave = xhr.responseJSON.erreurs
        })
    },
    downloadFile (csv, fileName) {
      var blob = new Blob(['\ufeff', csv])
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileName}.csv`)
      document.body.appendChild(link)
      link.click()
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/SyntheseComponent.vue